import { Button, fontSizes, sizes } from "@hubrise/react-components"
import styled from "styled-components"

import Tags from "Catalog/Preview/shared/components/Tags"

export const StyledPopup = styled.div`
  border-radius: ${sizes.borderRadius};
`

export const Details = styled.div``

export const Header = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Title = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1rem;

  font-family: "IBM Plex Sans", Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: ${fontSizes._24};
`

export const Footer = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`

export const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`

export const Name = styled.div``

export const StyledTags = styled(Tags)`
  flex: 1;
`

export const Price = styled.div``

export const DescriptionAndAllergens = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Description = styled.div`
  font-size: ${fontSizes._14};
  line-height: 1.5;
`

export const Edit = styled(Button).attrs({ icon: "edit", variant: "empty" })``

export const Close = styled(Button).attrs({ icon: "close", variant: "empty" })``
